export function addMouseEffectToElement(selector, rotationFactor = 100, scaleFactor = 1.07) {
    const element = document.querySelector(selector);
    if (!element) return;

    function rotateToMouse(e) {
        const bounds = element.getBoundingClientRect();
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        const leftX = mouseX - bounds.x;
        const topY = mouseY - bounds.y;
        const center = {
            x: leftX - bounds.width / 3,
            y: topY - bounds.height / 3,
        };
        const distance = Math.sqrt(center.x ** 2 + center.y ** 2);

        element.style.transform = `
      scale3d(${scaleFactor}, ${scaleFactor}, ${scaleFactor})
      rotate3d(
        ${center.y / rotationFactor},
        ${-center.x / rotationFactor},
        0,
        ${Math.log(distance) * 3}deg
      )
    `;
    }

    window.addEventListener('mousemove', rotateToMouse);

    return () => {
        window.removeEventListener('mousemove', rotateToMouse);
    };
}
